import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../core/config/api.config';
import {ADMISSIONS_SERVICE} from '../../core/config/api.constants';
import {endpoint} from '../path.constants';
import {ApiResponse} from '../api-response.model';
import {EnumData} from '../enum/enum.model';
import {PendingDocuments} from "../models/pending-document.model";
import {catchError, map, Observable, throwError} from "rxjs";


@Injectable({providedIn: 'root'})
export class AdmissionsService {
    private _instituteToken: string = "";
    private readonly baseUrl = ApiConfig.getBaseUrl(ADMISSIONS_SERVICE);

    constructor(private http: HttpClient) {
    }

    set setInstituteToken(value: string) {
        this._instituteToken = value;
    }

    getAdmissionEnum() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<{ enum_data: EnumData[] }>>(
            this.baseUrl + endpoint.admissions.enum, {headers}
        );
    }

    getPendingDocuments(application_number: string) {
        let headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        headers = headers.append('Institute-Token', this._instituteToken);
        const baseUrl = this.baseUrl + endpoint.admissions.pendingDocuments

        const url = baseUrl + '?application_number=' + application_number
        return this.http.get<ApiResponse<PendingDocuments>>(url, {headers});
    }

    uploadDocuments(requestData: any): Observable<any> {
        let headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        headers = headers.append('Institute-Token', this._instituteToken);
        const baseUrl = this.baseUrl + endpoint.admissions.uploadDocument

        return this.http.post<ApiResponse<any>>(baseUrl, requestData, {headers}).pipe(
            map(response => {
                if (response && !response.error && response.status_code === 200) {
                    return response.data;
                } else {
                    const errorMsg = response?.message?.message || 'Unexpected response structure';
                    return throwError(() => new Error(errorMsg));
                }
            }),
            catchError(error => error)
        );
    }

}
